<h1 class="text-3xl font-bold text-(--pg-brand-red)">{{title()}}</h1>
